import { isCustomDomain } from "@/utils/custom-domain";

/**
 * 手機版 App 模式的底部導覽列（components/Common/AppTabBar.vue）出現在哪幾頁。
 *
 * 首頁、會員中心（「商品訂單」「我的訂閱」與「更多」裡的項目都是它的分頁），
 * 加上不在分頁列上、但從首頁常進去的商品中心、終身俸計畫（「邀請分享」會分享這兩頁本身）。
 * 商品內頁、購物車、結帳這些頁面底下有自己的購買按鈕列，疊上去會擋住，所以不放 —— 跟一般 App 一樣，
 * 點進細節頁時分頁列收起來，返回才出現。
 */
export const APP_TAB_ROUTES = ["Home", "Product", "Upgrade", "Center"];

/** 登入後、這幾頁才顯示。子站網域是別人的品牌站，不放平台的導覽列。手機寬度由元件自己判斷 */
export function showsAppTabBar(route, signedIn) {
  if (!signedIn || !route) return false;
  if (isCustomDomain()) return false;
  return APP_TAB_ROUTES.includes(route.name);
}
